import React from "react";
import { richTextResolver } from "@website-builder/utilities/utils/TransformerHelpers.js";
import {
	HorizontalList,
	Link,
	Text,
	VerticalList,
	CloudinaryImage,
	Grid,
	Col,
} from "@website-builder/ui/shared/elements";
import { CenteredContentWrapper, LogoWrapper, ListItemWrapper } from "./style";
const CenteredContent = ({
	isDarkBackground,
	link,
	linkLabel = "",
	listHeader,
	description,
	logoHeader = "",
	logos = [],
	maxLogosInRow,
	header,
	topic = "",
	list = [],
	subHeader,
	globalVariableWithURL,
	descriptionBottom,
	sectionName,
}) => {
	const iconConfig = {
		iconName: "checkCircle",
		color: "var(--primary-forest-400)",
		size: "1.5rem",
	};
	const isTwoColumnSectionContent = sectionName === "TwoColumnSection";
	return (
		<CenteredContentWrapper
			className="centered-content outer-margin-wrap"
			isDarkBackground={isDarkBackground}
		>
			<Grid className="grid-container" hMargin={[48, 24]}>
				<Col
					start={isTwoColumnSectionContent ? 2 : 3}
					span={isTwoColumnSectionContent ? 10 : 8}
					mdStart={1}
					mdSpan={6}
				>
					{topic ? (
						<Text
							dark={isDarkBackground}
							className="topic-text"
							variant="label_M"
						>
							{topic}
						</Text>
					) : null}
					{header ? (
						<Text
							dark={isDarkBackground}
							className="header-text"
							variant="headline_3"
							tag="h2"
						>
							{header}
						</Text>
					) : null}
					{subHeader ? (
						<Text
							dark={isDarkBackground}
							className="sub-header-text"
							variant="paragraph_L_bold"
						>
							{subHeader}
						</Text>
					) : null}
					{description ? (
						<Text
							dark={isDarkBackground}
							className="description-text rich-text-wrapper"
							variant="paragraph_M"
							tag="div"
							dangerouslySetInnerHTML={{ __html: description }}
						/>
					) : null}
					{listHeader ? (
						<Text
							dark={isDarkBackground}
							className="list-header"
							variant="paragraph_M_bold"
						>
							{listHeader}
						</Text>
					) : null}
				</Col>
				{list?.length ? (
					<Col start={3} span={8} mdStart={1} mdSpan={6}>
						<VerticalList
							separator
							iconConfig={iconConfig}
							listItems={list.map(({ itemHeader, itemDescription }) => {
								const itemDescriptionInHTML = richTextResolver(
									itemDescription,
									globalVariableWithURL,
								);
								return (
									<ListItemWrapper>
										{itemHeader ? (
											<Text
												dark={isDarkBackground}
												className="item-header"
												variant="headline_6"
											>
												{itemHeader}
											</Text>
										) : null}
										{itemDescription ? (
											<Text
												dark={isDarkBackground}
												className="item-description rich-text-wrapper"
												variant="paragraph_S"
												tag="div"
												dangerouslySetInnerHTML={{
													__html: itemDescriptionInHTML,
												}}
											/>
										) : null}
									</ListItemWrapper>
								);
							})}
							gap="1rem"
							darkBg={isDarkBackground}
						/>
					</Col>
				) : null}
				<Col
					start={isTwoColumnSectionContent ? 2 : 3}
					span={isTwoColumnSectionContent ? 10 : 8}
					mdStart={1}
					mdSpan={6}
				>
					{descriptionBottom ? (
						<Text
							dark={isDarkBackground}
							className="description-text rich-text-wrapper"
							variant="paragraph_M"
							tag="div"
							dangerouslySetInnerHTML={{ __html: descriptionBottom }}
						/>
					) : null}
					{logos ? (
						<HorizontalList
							maxItems={maxLogosInRow}
							className="horizontal-list-container"
							labelConfig={logoHeader ? { text: logoHeader } : {}}
							listItems={logos?.map(
								({ image: { image: imageUrl = "", altTag = "" } = {} }, i) => (
									<LogoWrapper
										isDarkBg={isDarkBackground}
										key={`logo-image-${i}`}
									>
										<CloudinaryImage
											url={imageUrl}
											alt={altTag}
											lazyload
											sizes={{
												default: {
													width: 110,
												},
											}}
											className="logo-img centered-content-logo"
										/>
									</LogoWrapper>
								),
							)}
							gap="0.5rem"
						/>
					) : null}
					{linkLabel ? (
						<Link
							className="link"
							href={link?.link}
							target={link?.target}
							arrowCta
							darkBg={isDarkBackground}
							linkText={linkLabel}
						/>
					) : null}
				</Col>
			</Grid>
		</CenteredContentWrapper>
	);
};
export default CenteredContent;
